import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { ApplicationHeaderComponent } from '../../components/fcc-601/header/application-header/application-header.component';
import { ApplicationNavigationBarComponent } from '../../components/fcc-601/navigation-bar/application-navigation-bar.component';
import { ApplicationFooterComponent } from '../../components/fcc-601/footer/application-footer.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { LoadingComponent } from '../../components/loading/loading.component';

import { LoadingService } from '../../../core/services/loading/loading.service';

@Component({
    selector: 'app-unsupported-application-layout',
    standalone: true,
    templateUrl: './unsupported-application-layout.component.html',
    styleUrls: ['./unsupported-application-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterModule,
        SidenavComponent,
        ApplicationHeaderComponent,
        ApplicationNavigationBarComponent,
        ApplicationFooterComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
    ],
})
export class UnsupportedApplicationLayoutComponent {
    loading$ = this.loadingService.loading$;

    constructor(private readonly loadingService: LoadingService) {}
}
